import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, User, Filter, X } from 'lucide-react';
import api from './config';

function Hareketler() {
    const [hareketler, setHareketler] = useState([]);
    const [filteredHareketler, setFilteredHareketler] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filters, setFilters] = useState({
        islemTipi: 'Tümü',
        tarihBaslangic: '',
        tarihBitis: '',
        kullanici: ''
    });
    const [showFilters, setShowFilters] = useState(false);

    useEffect(() => {
        fetchHareketler();
    }, []);

    useEffect(() => {
        applyFilters();
    }, [filters, hareketler]);

    const fetchHareketler = async () => {
        try {
            const res = await api.get('/api/hareketler?limit=200');
            setHareketler(res.data);
            setFilteredHareketler(res.data);
            setLoading(false);
        } catch (err) {
            console.error('Hareketler yüklenemedi:', err);
            setLoading(false);
        }
    };

    const applyFilters = () => {
        let filtered = [...hareketler];

        // İşlem tipi filtresi
        if (filters.islemTipi !== 'Tümü') {
            filtered = filtered.filter(h => h.islem_tipi === filters.islemTipi);
        }

        // Tarih başlangıç filtresi
        if (filters.tarihBaslangic) {
            filtered = filtered.filter(h => {
                const hareketTarih = new Date(h.islem_tarihi);
                const baslangic = new Date(filters.tarihBaslangic);
                return hareketTarih >= baslangic;
            });
        }

        // Tarih bitiş filtresi
        if (filters.tarihBitis) {
            filtered = filtered.filter(h => {
                const hareketTarih = new Date(h.islem_tarihi);
                const bitis = new Date(filters.tarihBitis);
                bitis.setHours(23, 59, 59);
                return hareketTarih <= bitis;
            });
        }

        // Kullanıcı filtresi
        if (filters.kullanici) {
            filtered = filtered.filter(h =>
                h.kullanici_email?.toLowerCase().includes(filters.kullanici.toLowerCase())
            );
        }

        setFilteredHareketler(filtered);
    };

    const resetFilters = () => {
        setFilters({
            islemTipi: 'Tümü',
            tarihBaslangic: '',
            tarihBitis: '',
            kullanici: ''
        });
    };

    const getIslemRenk = (islemTipi) => {
        const renkler = {
            'Ekleme': '#10b981',
            'Güncelleme': '#3b82f6',
            'Pasif': '#ef4444',
            'Bakım': '#f59e0b',
            'Aktif': '#8b5cf6'
        };
        return renkler[islemTipi] || '#6b7280';
    };

    const formatTarih = (tarih) => {
        const d = new Date(tarih);
        return d.toLocaleString('tr-TR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const parseJSON = (jsonStr) => {
        try {
            return JSON.parse(jsonStr);
        } catch {
            return null;
        }
    };

    return (
        <div style={{ padding: '20px', backgroundColor: '#f3f4f6', minHeight: '100vh', fontFamily: 'sans-serif' }}>
            <div style={{ maxWidth: '1400px', margin: '0 auto' }}>

                <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', marginBottom: '20px', color: '#3b82f6', textDecoration: 'none' }}>
                    <ArrowLeft size={18} /> Ana Sayfa
                </Link>

                {/* HEADER */}
                <div style={{ ...panelStyle }}>
                    <h2 style={{ margin: 0 }}>📋 Sistem Hareketleri</h2>
                    <p style={{ margin: '5px 0 0', color: '#6b7280', fontSize: '14px' }}>
                        Toplam {filteredHareketler.length} kayıt
                    </p>
                </div>

                {/* FİLTRELER */}
                <div style={{ ...panelStyle }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: showFilters ? '15px' : 0 }}>
                        <button
                            onClick={() => setShowFilters(!showFilters)}
                            style={{ ...btnStyle, backgroundColor: '#3b82f6' }}
                        >
                            <Filter size={16} /> {showFilters ? 'Filtreleri Gizle' : 'Filtrele'}
                        </button>
                        {(filters.islemTipi !== 'Tümü' || filters.tarihBaslangic || filters.tarihBitis || filters.kullanici) && (
                            <button onClick={resetFilters} style={{ ...btnStyle, backgroundColor: '#ef4444' }}>
                                <X size={16} /> Filtreleri Temizle
                            </button>
                        )}
                    </div>

                    {showFilters && (
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', marginTop: '15px', paddingTop: '15px', borderTop: '1px solid #e5e7eb' }}>
                            <div>
                                <label style={{ fontSize: '14px', color: '#6b7280', marginBottom: '5px', display: 'block' }}>İşlem Tipi</label>
                                <select
                                    value={filters.islemTipi}
                                    onChange={e => setFilters({ ...filters, islemTipi: e.target.value })}
                                    style={{ ...inputStyle }}
                                >
                                    <option>Tümü</option>
                                    <option>Ekleme</option>
                                    <option>Güncelleme</option>
                                    <option>Pasif</option>
                                    <option>Bakım</option>
                                    <option>Aktif</option>
                                </select>
                            </div>
                            <div>
                                <label style={{ fontSize: '14px', color: '#6b7280', marginBottom: '5px', display: 'block' }}>Başlangıç Tarihi</label>
                                <input
                                    type="date"
                                    value={filters.tarihBaslangic}
                                    onChange={e => setFilters({ ...filters, tarihBaslangic: e.target.value })}
                                    style={{ ...inputStyle }}
                                />
                            </div>
                            <div>
                                <label style={{ fontSize: '14px', color: '#6b7280', marginBottom: '5px', display: 'block' }}>Bitiş Tarihi</label>
                                <input
                                    type="date"
                                    value={filters.tarihBitis}
                                    onChange={e => setFilters({ ...filters, tarihBitis: e.target.value })}
                                    style={{ ...inputStyle }}
                                />
                            </div>
                            <div>
                                <label style={{ fontSize: '14px', color: '#6b7280', marginBottom: '5px', display: 'block' }}>Kullanıcı Email</label>
                                <input
                                    type="text"
                                    placeholder="Ara..."
                                    value={filters.kullanici}
                                    onChange={e => setFilters({ ...filters, kullanici: e.target.value })}
                                    style={{ ...inputStyle }}
                                />
                            </div>
                        </div>
                    )}
                </div>

                {/* HAREKETLER LİSTESİ */}
                <div style={{ ...panelStyle }}>
                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
                            Yükleniyor...
                        </div>
                    ) : filteredHareketler.length === 0 ? (
                        <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
                            Henüz hareket kaydı bulunmuyor.
                        </div>
                    ) : (
                        <div style={{ overflowX: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#f9fafb', borderBottom: '2px solid #e5e7eb' }}>
                                        <th style={{ ...thStyle }}>Tarih</th>
                                        <th style={{ ...thStyle }}>Tablo</th>
                                        <th style={{ ...thStyle }}>Kayıt ID</th>
                                        <th style={{ ...thStyle }}>İşlem</th>
                                        <th style={{ ...thStyle }}>Kullanıcı</th>
                                        <th style={{ ...thStyle }}>Açıklama</th>
                                        <th style={{ ...thStyle }}>Detay</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredHareketler.map((hareket) => (
                                        <tr key={hareket.hareket_id} style={{ borderBottom: '1px solid #e5e7eb' }}>
                                            <td style={{ ...tdStyle }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <Calendar size={14} color="#6b7280" />
                                                    <span style={{ fontSize: '13px' }}>{formatTarih(hareket.islem_tarihi)}</span>
                                                </div>
                                            </td>
                                            <td style={{ ...tdStyle }}>
                                                <span style={{ fontWeight: 'bold', color: '#374151' }}>{hareket.tablo_adi}</span>
                                            </td>
                                            <td style={{ ...tdStyle }}>
                                                <span style={{ color: '#6b7280' }}>#{hareket.kayit_id}</span>
                                            </td>
                                            <td style={{ ...tdStyle }}>
                                                <span style={{
                                                    backgroundColor: getIslemRenk(hareket.islem_tipi) + '20',
                                                    color: getIslemRenk(hareket.islem_tipi),
                                                    padding: '4px 12px',
                                                    borderRadius: '12px',
                                                    fontSize: '13px',
                                                    fontWeight: 'bold'
                                                }}>
                                                    {hareket.islem_tipi}
                                                </span>
                                            </td>
                                            <td style={{ ...tdStyle }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <User size={14} color="#6b7280" />
                                                    <span style={{ fontSize: '13px' }}>
                                                        {hareket.kullanici_email || <span style={{ color: '#9ca3af' }}>Sistem</span>}
                                                    </span>
                                                </div>
                                            </td>
                                            <td style={{ ...tdStyle }}>
                                                <span style={{ fontSize: '13px', color: '#6b7280' }}>{hareket.aciklama}</span>
                                            </td>
                                            <td style={{ ...tdStyle }}>
                                                <HareketDetayModal hareket={hareket} />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

function HareketDetayModal({ hareket }) {
    const [showModal, setShowModal] = useState(false);
    const eskiDeger = hareket.eski_deger ? JSON.parse(hareket.eski_deger) : null;
    const yeniDeger = hareket.yeni_deger ? JSON.parse(hareket.yeni_deger) : null;

    return (
        <>
            <button
                onClick={() => setShowModal(true)}
                style={{ ...btnStyle, backgroundColor: '#6b7280', fontSize: '12px', padding: '6px 12px' }}
            >
                Görüntüle
            </button>

            {showModal && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
                    <div style={{ backgroundColor: 'white', padding: '30px', borderRadius: '12px', width: '600px', maxWidth: '90%', maxHeight: '80vh', overflow: 'auto' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                            <h3 style={{ margin: 0 }}>📋 Hareket Detayı</h3>
                            <button onClick={() => setShowModal(false)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                                <X size={20} />
                            </button>
                        </div>

                        <div style={{ marginBottom: '15px' }}>
                            <strong>İşlem Tipi:</strong>
                            <span style={{
                                marginLeft: '10px',
                                backgroundColor: '#3b82f620',
                                color: '#3b82f6',
                                padding: '4px 12px',
                                borderRadius: '12px',
                                fontSize: '13px'
                            }}>
                                {hareket.islem_tipi}
                            </span>
                        </div>

                        <div style={{ marginBottom: '15px' }}>
                            <strong>Tarih:</strong> {new Date(hareket.islem_tarihi).toLocaleString('tr-TR')}
                        </div>

                        <div style={{ marginBottom: '15px' }}>
                            <strong>Kullanıcı:</strong> {hareket.kullanici_email || 'Sistem'}
                        </div>

                        {eskiDeger && (
                            <div style={{ marginBottom: '15px' }}>
                                <strong>Eski Değer:</strong>
                                <pre style={{ backgroundColor: '#f9fafb', padding: '10px', borderRadius: '8px', fontSize: '12px', overflow: 'auto' }}>
                                    {JSON.stringify(eskiDeger, null, 2)}
                                </pre>
                            </div>
                        )}

                        {yeniDeger && (
                            <div style={{ marginBottom: '15px' }}>
                                <strong>Yeni Değer:</strong>
                                <pre style={{ backgroundColor: '#f0fdf4', padding: '10px', borderRadius: '8px', fontSize: '12px', overflow: 'auto' }}>
                                    {JSON.stringify(yeniDeger, null, 2)}
                                </pre>
                            </div>
                        )}

                        {hareket.aciklama && (
                            <div>
                                <strong>Açıklama:</strong>
                                <p style={{ color: '#6b7280', marginTop: '5px' }}>{hareket.aciklama}</p>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
}

const panelStyle = { backgroundColor: 'white', padding: '20px', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', marginBottom: '20px' };
const btnStyle = { color: 'white', border: 'none', borderRadius: '8px', padding: '10px 20px', cursor: 'pointer', fontWeight: 'bold', display: 'inline-flex', alignItems: 'center', gap: '8px' };
const inputStyle = { width: '100%', padding: '8px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '14px' };
const thStyle = { padding: '12px', textAlign: 'left', fontSize: '14px', fontWeight: 'bold', color: '#374151' };
const tdStyle = { padding: '12px', fontSize: '14px' };

export default Hareketler;
